import { render, staticRenderFns } from "./DlgUploadTask.vue?vue&type=template&id=4db8df60&scoped=true"
import script from "./DlgUploadTask.vue?vue&type=script&lang=js"
export * from "./DlgUploadTask.vue?vue&type=script&lang=js"
import style0 from "./DlgUploadTask.vue?vue&type=style&index=0&id=4db8df60&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4db8df60",
  null
  
)

export default component.exports